module.exports = __webpack_public_path__ + "img/han.f2a9a53c.png";